import { useSelector } from 'react-redux';

import Global from '../../../store/global-selectors';
import { HAS_DISMISSED_PLAN_TRIAL_EXPIRED_BANNER, useUserSpecificLocalStorage } from '../../../hooks/use-local-storage';
import { useGetExpiredPlanTrialData } from './use-get-expired-plan-trial-data';
import { TRIALED_PLAN_TO_SATISFYING_UPGRADE_PLAN_IDS } from '../billing-plan-trial-banner/plan-trial-constants';

/**
 * Determines whether the BillingPlanTrialExpiredBanner should be shown.
 * Shows when:
 * - A plan trial has expired
 * - User hasn't upgraded to the trialed tier (or higher)
 * - User hasn't dismissed the banner for this specific tier
 */
export const useShouldShowPlanTrialExpiredBanner = (): boolean => {
  const { isTrialExpired, expiredPlanCode } = useGetExpiredPlanTrialData();
  const { currentBillingPlan } = useSelector(Global.selectSellerSubscriptionData) ?? {};
  const billingPlanId = Number.parseInt(currentBillingPlan?.billingPlanId ?? 0, 10);
  const planSpecificKey = `${HAS_DISMISSED_PLAN_TRIAL_EXPIRED_BANNER}/${expiredPlanCode}`;
  const [isDismissed] = useUserSpecificLocalStorage(planSpecificKey);

  const satisfyingPlanIds = TRIALED_PLAN_TO_SATISFYING_UPGRADE_PLAN_IDS[expiredPlanCode] ?? [];
  const hasUpgradedToTrialedTierOrHigher = satisfyingPlanIds.includes(billingPlanId);

  return isTrialExpired && !hasUpgradedToTrialedTierOrHigher && !isDismissed;
};
